import type { ValueSubtypeDefinition } from "../valueSubtypeDefinition.ts";
import { localeValueSubtypeDefinition } from "./locale/localeValueSubtypeDefinition.ts";

/**
 * The subtypes core itself owns, resolved ahead of anything an app contributes.
 *
 * A subtype normally belongs to the package that declares it on a value, and core
 * declares none — except on its own external values, which no node or app is in a
 * position to define. Those go here, so a designer app gets them without wiring
 * and cannot half-wire them.
 */
export const coreValueSubtypeDefinitions: readonly ValueSubtypeDefinition[] = [
  localeValueSubtypeDefinition as ValueSubtypeDefinition,
];
